import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BlackRedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Remove '/black' prefix and redirect
    const newUrl = state.url.replace(/^\/black/, '');
    this.router.navigateByUrl(newUrl || '/');
    return false;
  }
}
